export default __webpack_public_path__ + "static/media/bxl-linkedin.516cb587.svg";